import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var variantImageSchema = {
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    image_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'image',
        label: 'Aдрес картинка*',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна картинка',
    }),
};
export default variantImageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/variantImageSchema.ts
// module id = 499
// module chunks = 0